import { useState, useEffect } from "react";
import { X, Share } from "lucide-react";

const DISMISS_KEY = "tip_ios_hint_dismissed";

export const IosInstallHint = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const ua = window.navigator.userAgent || "";
    const isIOS =
      /iphone|ipad|ipod/i.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    // Safari only (Chrome/Firefox on iOS can't add to home screen the same way)
    const isSafari = /safari/i.test(ua) && !/crios|fxios|edgios/i.test(ua);
    const inStandalone =
      window.navigator.standalone === true ||
      window.matchMedia("(display-mode: standalone)").matches;
    const dismissed = localStorage.getItem(DISMISS_KEY) === "1";

    if (isIOS && isSafari && !inStandalone && !dismissed) {
      const t = setTimeout(() => setShow(true), 2500);
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="ios-install-hint"
      className="fixed inset-x-3 bottom-3 z-[100] mx-auto max-w-md animate-in fade-in slide-in-from-bottom-4"
    >
      <div className="relative rounded-2xl border border-white/10 bg-[#0F0F0F]/95 p-4 pr-10 shadow-2xl backdrop-blur-xl">
        <button
          data-testid="ios-hint-dismiss"
          onClick={dismiss}
          aria-label="Dismiss"
          className="absolute right-2 top-2 rounded-full p-1.5 text-zinc-500 transition-colors hover:bg-white/5 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="flex items-center gap-3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#00E676]">
            <span className="font-display text-sm font-black text-black">TN</span>
          </span>
          <p className="text-sm leading-relaxed text-zinc-300">
            Install <span className="font-bold text-white">TipNu</span> — tap{" "}
            <Share className="mx-0.5 inline h-4 w-4 -translate-y-0.5 text-[#00E676]" />{" "}
            <span className="font-semibold text-white">Share</span>, then{" "}
            <span className="font-semibold text-white">"Add to Home Screen"</span>.
          </p>
        </div>
      </div>
    </div>
  );
};
